﻿<template>

    <div class="lg-head">
        <span class="lg-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" /></svg>
        </span>
        <h2 class="lg-heading">Select consultant</h2>
        <p class="lg-intro">Account <strong>{{get_Agent_Info()?.agency?.name}}</strong></p>
    </div>

    <login_alert :message="error_message" @dismiss="error_message = ''"></login_alert>

    <div class="lg-form">
        <div class="mb-field">
            <label id="consultant_label">Consultant</label>
            <div class="lg-select" id="Select_Consultant_Click_Away" v-click-away="Consultant_Click_Away">
                <button type="button" class="lg-select-btn" :class="{ 'is-open': isOpen }" aria-haspopup="listbox" :aria-expanded="isOpen" aria-labelledby="consultant_label" @click="isOpen = !isOpen">
                    <span class="lg-select-value">
                        <span class="lg-select-name">{{selected_contact.first_name}} {{selected_contact.second_name}}</span>
                        <span class="lg-select-email">{{selected_contact.email}}</span>
                    </span>
                    <svg class="lg-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 9l6 6 6-6" /></svg>
                </button>
                <ul v-if="isOpen" class="lg-select-list" role="listbox" aria-labelledby="consultant_label">
                    <li v-for="contact in get_Agent_Info().contacts" :key="contact.contact_id" role="option"
                        :aria-selected="contact.contact_id === selected_contact.contact_id"
                        :class="{ 'is-selected': contact.contact_id === selected_contact.contact_id }"
                        @click="contact_selected(contact)">
                        <span class="lg-select-name">{{contact.first_name}} {{contact.second_name}}</span>
                        <span class="lg-select-email">{{contact.email}}</span>
                    </li>
                </ul>
            </div>
        </div>

        <button type="button" class="lg-link lg-link-inline" :aria-expanded="newProfileOpen" @click="NewProfile()">
            Can't find your name? Create a profile
        </button>

        <template v-if="newProfileOpen">
            <div class="mb-field">
                <label for="consultant_new_name">Consultant name</label>
                <input class="mb-input" type="text" name="name" id="consultant_new_name" autocomplete="name" v-model="new_contact.first_name" placeholder="Consultant name">
            </div>
            <div class="mb-field">
                <label for="consultant_new_email">Consultant email</label>
                <input class="mb-input" type="email" name="email" id="consultant_new_email" autocomplete="email" spellcheck="false" v-model="new_contact.email" placeholder="consultant@email.com">
            </div>
        </template>

        <button type="button" class="button button-pink-book full lg-submit" :disabled="logging_in" @click="Click_Continue()">
            <svg v-if="logging_in" class="mb-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            {{ButtonText()}}
        </button>
    </div>

</template>

<script lang="ts" src="./select_consultant.ts"></script>
